import { RefObject, useEffect, useRef } from "react";
import { IMessage } from "../../../types/Message";

export const useScrollEffects = (
  isLoading: boolean,
  scrollContainer: RefObject<HTMLDivElement>,
  data: IMessage[]
) => {
  const anchor = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainer) {
      const { current } = scrollContainer;

      if (
        current &&
        current.scrollHeight - current.scrollTop <= current.clientHeight + 300
      ) {
        current.scrollTop = current.scrollHeight - current.clientHeight;
      }
    }
  }, [data, scrollContainer]);

  useEffect(() => {
    !isLoading && anchor.current?.scrollIntoView();
  }, [isLoading]);

  return { anchor };
};
